import React from "react";
import { useUtilityStyles } from "./hooks/useUtilityStyles";
import { classNames } from "./utils/classNames";
export const Title = ({ titleLevel = "span", extraClass, children, dataId, dataTestId, dataHook, styleOptions, }) => {
    const { utilities } = useUtilityStyles(styleOptions);
    const Component = titleLevel;
    return (React.createElement(Component, { className: classNames(utilities, extraClass), "data-id": dataId, "data-testid": dataTestId, "data-hook": dataHook }, children));
};
